import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';

function App() {

      const [showScroll, setShowScroll] = useState(false);
  const [menuActive, setMenuActive] = useState(false);

  // Handle Scroll Logic (React Way)
  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
      <>
        <div className="container-fluid ">
          <div className="row bg-color">
            {/* NAVBAR */}
            <div className="col-12 d-flex align-items-center mt-3">
              {/* Logo */}
              <div className="d-flex ps-3 mt-2" style={{ height: 45 }}>
                <img src="assets/images/logo.png" alt="" />
              </div>
              {/* Desktop Navbar */}
              <div
                className="navbar gap-4 d-none d-lg-flex"
                style={{ paddingLeft: "12rem" }}
              >
                <a href="">Home</a>
                <a href="">Menu</a>
                <a href="">Offer</a>
                <a href="">Service</a>
                <a href="">About Us</a>
              </div>
              {/* Desktop Icons */}
              <div
                className="d-flex mt-1 gap-3 d-none d-lg-flex"
                style={{ height: 43, paddingLeft: "13rem" }}
              >
                {/* Search Box (Desktop) */}
                <div className="search-box">
                  <i className="fa-solid fa-magnifying-glass" />
                  <input
                    type="text"
                    placeholder="Search..."
                    className="search-input"
                  />
                </div>
                {/* Person Icon */}
                <img src="assets/images/personimg-navbar.png" alt="" />
              </div>
              {/* Hamburger */}
              <button
                  className="hamburger d-lg-none ms-auto mt-4 me-3"
                  // Change 'onclick' to 'onClick' and link it to your toggle function
                  onClick={() => setMenuActive(!menuActive)} 
                >
                  ☰
              </button>
            </div>
            {/* Mobile Menu */}
            <div 
              id="mobileMenu" 
              className={`mobile-menu d-lg-none ${menuActive ? 'active' : ''}`}
              style={{ display: menuActive ? 'block' : 'none' }} 
            >
              <a href="">Home</a>
              <a
                href=""
                style={{
                  color: "gray",
                  textDecoration: "none",
                  fontFamily: "Lexend",
                  fontWeight: 500
                }}
              >
                Menu
              </a>
              <a
                href=""
                style={{
                  color: "gray",
                  textDecoration: "none",
                  fontFamily: "Lexend",
                  fontWeight: 500
                }}
              >
                Offer
              </a>
              <a
                href=""
                style={{
                  color: "gray",
                  textDecoration: "none",
                  fontFamily: "Lexend",
                  fontWeight: 500
                }}
              >
                Service
              </a>
              <a
                href=""
                style={{
                  color: "gray",
                  textDecoration: "none",
                  fontFamily: "Lexend",
                  fontWeight: 500
                }}
              >
                About Us
              </a>
              <div className="d-flex gap-3 mt-3 align-items-center">
                <div className="search-box">
                  <i className="fa-solid fa-magnifying-glass" />
                  <input
                    type="text"
                    placeholder="Search..."
                    className="search-input"
                  />
                </div>
                <img src="assets/images/personimg-navbar.png" alt="" />
              </div>
            </div>
            {/* CONTENT */}
            <div className="col-lg-7 col-12 d-flex flex-column align-items-lg-start align-items-center justify-content-center ps-5">
              <div className="h-heading mt-4">
                <span className="orange-txt">Quick</span> and
                <span className="orange-txt">Tasty</span>
                <span className="orange-txt">Food Delivered</span>
                with <span className="orange-txt">a</span>
                <span className="orange-txt">Dash of</span>Speed
              </div>
              <button className="btn-order-now rounded-pill mt-5">Order Now</button>
              <button className="btn-track-now rounded-pill my-3">Track Order</button>
            </div>
            {/* IMAGE */}
            <div className="col-lg-5 col-12 pe-4 text-center">
              <img
                src="assets/images/header-img.png"
                alt=""
                className="pe-4 mt-4 img-fluid"
              />
            </div>
            {/*second section*/}
            <div className="row position-absolute top-50 start-50 translate-middle">
              <div className="col-12 second-section d-flex">
                <div className="d-flex mx-3 mt-3">
                  <div>
                    <img src="assets/images/fast-delivery-img.png" alt="" />
                  </div>
                  <div className="mx-3">
                    <h4 className="second-section-heading">Fast Delivery</h4>
                    <p className="second-section-descripation">
                      Promise To Deliver Within 30 Mins
                    </p>
                  </div>
                </div>
                <div className="d-flex mx-3 mt-3">
                  <div>
                    <img src="assets/images/fresh-food-img.png" alt="" />
                  </div>
                  <div className="mx-3">
                    <h4 className="second-section-heading">Fresh Food</h4>
                    <p className="second-section-descripation">
                      Your Food Will Be Delivered 100% Fresh To Your Home.
                    </p>
                  </div>
                </div>
                <div className="d-flex mx-3 mt-3">
                  <div>
                    <img src="assets/images/free-delivery-img.png" alt="" />
                  </div>
                  <div className="mx-3">
                    <h4 className="second-section-heading">Free Delivery</h4>
                    <p className="second-section-descripation">
                      Your Food Delivery Is Absolutely Free.No Cost Just Order
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Third Section*/}
          <div className="row third-row">
            <div className="d-flex ">
              <div
                className="col-6 third-section-heading"
                style={{ paddingLeft: 80 }}
              >
                Our
                <span className="orange-txt">Best Delivered</span>
                <div>Indian Dish</div>
              </div>
              <div
                className="col-6 third-section-subheading"
                style={{ paddingLeft: 170 }}
              >
                It’s Not Just About Bringing You Good Food
                <div>From Restaurants, We Deliver You Experience</div>
              </div>
            </div>
          </div>
          {/*Third Section ends*/}
          {/*Fourth section*/}
          <div className="row fourth-section">
            <div
              className="col-4 d-flex flex-column align-items-center "
              style={{ marginTop: "3rem", marginBottom: "4rem" }}
            >
              <img src="assets/images/item-1.png" alt="" />
              <div className="items">Indian Vegetable Pulao</div>
              <a href="" style={{ textDecoration: "none" }}>
                <span className="order-now-orange-txt">Order Now &gt;</span>
              </a>
            </div>
            <div
              className="col-4 d-flex flex-column align-items-center "
              style={{ marginTop: "3rem", marginBottom: "4rem" }}
            >
              <img src="assets/images/item-2.png" alt="" />
              <div className="items">Paneer Bhuna Masala</div>
              <a href="" style={{ textDecoration: "none" }}>
                <span className="order-now-orange-txt">Order Now &gt; </span>
              </a>
            </div>
            <div
              className="col-4 d-flex flex-column align-items-center "
              style={{ marginTop: "3rem", marginBottom: "4rem" }}
            >
              <img src="assets/images/item-3.png" alt="" />
              <div className="items">Vermicelli Upma</div>
              <a href="" style={{ textDecoration: "none" }}>
                <span className="order-now-orange-txt">Order Now &gt; </span>
              </a>
            </div>
          </div>
          {/*forth section ends */}
          {/*fifth section*/}
          <div className="row fifth-section-bg-color">
            <div className="col-12 d-flex">
              <div className="d-flex col-3">
                <img src="assets/images/rajistan.png" alt="" />
              </div>
              <div className="d-flex col-3">
                <img src="assets/images/south-indian.png" alt="" />
              </div>
              <div className="d-flex col-2">
                <img src="assets/images/gujrat.png" alt="" />
              </div>
              <div className="d-flex col-3" style={{ paddingRight: 100 }}>
                <img src="assets/images/maharastra.png" alt="" />
              </div>
              <div className="d-flex col-1">
                <img src="assets/images/wes.png" alt="" />
              </div>
            </div>
          </div>
          {/*fifth section end*/}
          {/*sixth section*/}
          <div className="row sixth-section">
            <div className="d-flex sixth-flex">
              <div className="col-6 regular-menu-heading" style={{ paddingLeft: 80 }}>
                Our
                <span className="orange-txt">Regular</span>Menu
                <div className="regular-menu-subheading mt-3">
                  There Are Our Regular Menus.
                  <div>You Can Order Anything You Like. </div>
                </div>
              </div>
              <div className="col-6" style={{ paddingLeft: 390 }}>
                <button className="regular-menu-btn rounded-pill mt-3">
                  See All
                </button>
              </div>
            </div>
          </div>
          {/*sixth section end*/}
          {/* seventh section start */}
          <div className="row seven-section">
            {/* CARD 1 */}
            <div className="col-lg-4 col-12 d-flex justify-content-center mb-5">
              <div className="bg-menu-item-color">
                <div className="menu-img-wrap">
                  <img
                    src="assets/images/menu/menu-item1.png"
                    className="menu-img"
                    alt=""
                  />
                </div>
                <div className="menu-item-heading mt-5 ps-3">
                  <span className="menu-item-orange-txt">Indian Dessert</span>
                </div>
                <div className="menu-item-heading ps-3">Angoori Rasmalai</div>
                <img
                  src="assets/images/menu/rating.png"
                  className="rating-img ps-3"
                  alt=""
                />
                <div className="d-flex align-items-center">
                  <div className="menu-item-price ps-3 mt-3">₹250</div>
                  <button className="menu-item-orange-btn rounded-pill mt-2 ms-3">
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
            {/* CARD 2 */}
            <div className="col-lg-4 col-12 d-flex justify-content-center mb-5">
              <div className="bg-menu-item-color">
                <div className="menu-img-wrap">
                  <img
                    src="assets/images/menu/menu-item2.png"
                    className="menu-img"
                    alt=""
                  />
                </div>
                <div className="menu-item-heading mt-5 ps-3">
                  <span className="menu-item-orange-txt">Indian</span>
                </div>
                <div className="menu-item-heading ps-3">Tea Time Snacks</div>
                <img
                  src="assets/images/menu/rating.png"
                  className="rating-img ps-3"
                  alt=""
                />
                <div className="d-flex align-items-center">
                  <div className="menu-item-price ps-3 mt-3">₹250</div>
                  <button className="menu-item-orange-btn rounded-pill mt-2 ms-3">
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
            {/* CARD 3 */}
            <div className="col-lg-4 col-12 d-flex justify-content-center mb-5">
              <div className="bg-menu-item-color">
                <div className="menu-img-wrap">
                  <img
                    src="assets/images/menu/menu-item3.png"
                    className="menu-img"
                    alt=""
                  />
                </div>
                <div className="menu-item-heading mt-5 ps-3">
                  <span className="menu-item-orange-txt">Indian</span>
                </div>
                <div className="menu-item-heading ps-3">Tea Time Snacks</div>
                <img
                  src="assets/images/menu/rating.png"
                  className="rating-img ps-3"
                  alt=""
                />
                <div className="d-flex align-items-center">
                  <div className="menu-item-price ps-3 mt-3">₹200</div>
                  <button className="menu-item-orange-btn rounded-pill mt-2 ms-3">
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
            {/* CARD 4 */}
            <div className="col-lg-4 col-12 d-flex justify-content-center mb-5">
              <div className="bg-menu-item-color">
                <div className="menu-img-wrap">
                  <img
                    src="assets/images/menu/menu-item4.png"
                    className="menu-img"
                    alt=""
                  />
                </div>
                <div className="menu-item-heading mt-5 ps-3">
                  <span className="menu-item-orange-txt">South Indian</span>
                </div>
                <div className="menu-item-heading ps-3">Masala Dosa</div>
                <img
                  src="assets/images/menu/rating.png"
                  className="rating-img ps-3"
                  alt=""
                />
                <div className="d-flex align-items-center">
                  <div className="menu-item-price ps-3 mt-3">₹150</div>
                  <button className="menu-item-orange-btn rounded-pill mt-2 ms-3">
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
            {/* CARD 5 */}
            <div className="col-lg-4 col-12 d-flex justify-content-center mb-5">
              <div className="bg-menu-item-color">
                <div className="menu-img-wrap">
                  <img
                    src="assets/images/menu/menu-item5.png"
                    className="menu-img"
                    alt=""
                  />
                </div>
                <div className="menu-item-heading mt-5 ps-3">
                  <span className="menu-item-orange-txt">Gujarati</span>
                </div>
                <div className="menu-item-heading ps-3">Pav Bhaji</div>
                <img
                  src="assets/images/menu/rating.png"
                  className="rating-img ps-3"
                  alt=""
                />
                <div className="d-flex align-items-center">
                  <div className="menu-item-price ps-3 mt-3">₹250</div>
                  <button className="menu-item-orange-btn rounded-pill mt-2 ms-3">
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
            {/* CARD 6 */}
            <div className="col-lg-4 col-12 d-flex justify-content-center mb-5">
              <div className="bg-menu-item-color">
                <div className="menu-img-wrap">
                  <img
                    src="assets/images/menu/menu-item6.png"
                    className="menu-img"
                    alt=""
                  />
                </div>
                <div className="menu-item-heading mt-5 ps-3">
                  <span className="menu-item-orange-txt">Rajasthan</span>
                </div>
                <div className="menu-item-heading ps-3">Dal Bati Churma</div>
                <img
                  src="assets/images/menu/rating.png"
                  className="rating-img ps-3"
                  alt=""
                />
                <div className="d-flex align-items-center">
                  <div className="menu-item-price ps-3 mt-3">₹450</div>
                  <button className="menu-item-orange-btn rounded-pill mt-2 ms-3">
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* seventh section ends */}
          {/* eight section */}
          <div className="row eight-section">
            <div className="col-12 d-flex justify-content-center align-items-start">
              {/* Left Side Image */}
              <div className="left-img">
                <img src="assets/images/Indian 1.png" alt="" />
              </div>
              {/* Right Side Images */}
              <div className="right-imgs">
                <div className="top-right-img">
                  <img src="assets/images/25off.png" alt="" />
                </div>
                <div className="bottom-right-img">
                  <img src="assets/images/indian-restraunt.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          {/* eight section end */}
          {/* Footer */}
          <div className="row bg-footer-color footer-row">
            {/* Menu */}
            <div className="col-3 footer-col">
              <div className="footer-title">Menu</div>
              <a href="">Home</a>
              <a href="">Offers</a>
              <a href="">Service</a>
              <a href="">About Us</a>
            </div>
            {/* Information */}
            <div className="col-3 footer-col">
              <div className="footer-title">Information</div>
              <a href="">Menu</a>
              <a href="">Quality</a>
              <a href="">Make a Choice</a>
              <a href="">Fast Delivery</a>
            </div>
            {/* Contact */}
            <div className="col-3 footer-col">
              <div className="footer-title">Contact</div>
              <a href="">+123456789</a>
              <a href="">Explore</a>
              <a href="">Info@Fooddash.com</a>
              <a href="">12, Maharashtra, India</a>
            </div>
            {/* Logo & Social */}
            <div className="col-3 footer-col footer-logo-col">
              <img
                src="assets/images/logo.png"
                alt="Food Dash Logo"
                className="footer-logo"
              />
              <div className="footer-text">Food Dash ©2023 All Rights Reserved</div>
              <div className="footer-text">By - Maira Sajid</div>
              <div className="footer-title follow-us">Follow Us On</div>
              <div className="social-icons">
                <a href="#" className="social-icon">
                  <i className="fa-brands fa-facebook-f" />
                </a>
                <a href="#" className="social-icon">
                  <i className="fa-brands fa-instagram" />
                </a>
                <a href="#" className="social-icon">
                  <i className="fa-brands fa-twitter" />
                </a>
                <a href="#" className="social-icon">
                  <i className="fa-brands fa-youtube" />
                </a>
              </div>
            </div>
          </div>
          {/* Footer end */}
        </div>
        {/* Scroll To Top Button */}
        <button 
        id="scrollTopBtn" 
        onClick={scrollToTop}
        style={{ display: showScroll ? 'block' : 'none' }}
        title="Go to top"
      >
        <i className="fa-solid fa-arrow-up" />
      </button>
      </>

  );
}

export default App;
